@if(showButton){<button class="scroll-to-top-btn" (click)="scrollToTop()" aria-label="Scroll to top">
  <!--<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 20L12 4M12 4L5 11M12 4L19 11" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>-->
  <img src="assets/images/icons/scroll-up.png" alt="">
</button> }